import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { A11yModule } from '@angular/cdk/a11y';
import { UserRevokeModalComponent } from './user-revoke-modal.component';
import { ModalLayoutModule } from '../modal-layout/modal-layout.module';

@NgModule({
  declarations: [UserRevokeModalComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule, ModalLayoutModule, A11yModule],
  exports: [UserRevokeModalComponent],
})
export class UserRevokeModalModule {}
